// extracted by mini-css-extract-plugin
module.exports = {"copyLink":"CopyLink_copyLink__2aJtX","url":"CopyLink_url__2UB6V","button":"CopyLink_button__2vUh_"};